/* eslint-disable @typescript-eslint/no-unused-vars */
import { z } from 'zod'

import type { Equal, ExpectTrue } from '../types/validation'

import { type CTALink, CTALinkSchema } from './cta-link'

export type TradeInSearchProps = {
  technicalName?: string
  label?: string
  ctaLink?: CTALink
  helperText?: string
}

export const TradeInSearchSchema = z.object({
  technicalName: z.string().optional(),
  label: z.string().optional(),
  ctaLink: CTALinkSchema.optional(),
  helperText: z.string().optional(),
})

// Schema validation
type TestTradeInSearchProps = ExpectTrue<
  Equal<TradeInSearchProps, z.infer<typeof TradeInSearchSchema>>
>
